import { PrNumberPipe } from './ea-number.pipe';
import { PrRoundPipe } from './ea-round.pipe';
import { NgModule } from '@angular/core';
import { PrReversePipe } from './ea-invert.pipe';
import { PrDateFormatPipe } from './ea-dateformat.pipe';
import { PrDurationPipe } from './ea-duration.pipe';
import { PrSafeHtmlPipe } from './ea-safe-html.pipe';
import { PrMathPipe } from './ea-math.pipe';
import { EaSafeResourceUrlPipe } from './ea-safe-resource-url.pipe';
import { EaSafeUrlPipe } from './ea-safe-url.pipe';
import { TruncateTextPipe } from './ea-truncate.pipe';
import { UpperCasePipe } from './upper-case.pipe';
import { SearchFilterPipe } from './search-filter.pipe';
import { LimitToPipe } from './limit-to.pipe';
import { PrCustomCapitalizePipe } from './ea-custom-capitalize.pipe';
@NgModule({
  declarations: [
    PrNumberPipe,
    PrRoundPipe,
    PrReversePipe,
    PrDateFormatPipe,
    PrDurationPipe,
    PrSafeHtmlPipe,
    EaSafeUrlPipe,
    EaSafeResourceUrlPipe,
    PrMathPipe,
    TruncateTextPipe,
    UpperCasePipe,
    SearchFilterPipe,
    LimitToPipe,
    PrCustomCapitalizePipe,
  ],
  exports: [
    PrNumberPipe,
    PrRoundPipe,
    PrReversePipe,
    PrDateFormatPipe,
    PrDurationPipe,
    PrSafeHtmlPipe,
    EaSafeUrlPipe,
    EaSafeResourceUrlPipe,
    PrMathPipe,
    TruncateTextPipe,
    PrCustomCapitalizePipe,
  ],
  providers: [
    PrNumberPipe,
    PrRoundPipe,
    PrReversePipe,
    PrDateFormatPipe,
    PrDurationPipe,
    PrSafeHtmlPipe,
    EaSafeUrlPipe,
    EaSafeResourceUrlPipe,
    PrMathPipe,
    TruncateTextPipe,
    PrCustomCapitalizePipe,
  ],
})
export class EaPipesModule {}
